/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * War Room State
 *
 * @type {Object}
 */
const state = {
    loading: false,
    isEditing: false,
    showMenu: false,
    data: {
        meta: {
            address: {},
            company_resources: {}
        },
        sections: []
    },
    newPageModal: {
        showModal: false,
        sectionId: null,
        sectionIndex: null,
        pageId: null,
        pageIndex: null
    },
    layouts: [
        { name: 'layout_one', components: 4 },
        { name: 'layout_two', components: 3 },
        { name: 'layout_three', components: 2 },
        { name: 'layout_four', components: 3 },
        { name: 'layout_five', components: 2 },
        { name: 'layout_six', components: 3 },
        { name: 'layout_seven', components: 1 },
        { name: 'layout_eight', components: 3 },
        { name: 'layout_nine', components: 9 },
        { name: 'layout_ten', components: 6 }
    ]
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/dom-alt/state.js